(function () {
  'use strict';
  function validate(action = {}) {
    let returnable;
    if (
      angular.isString(action.supplierId) &&
      angular.isObject(action.supplier) &&
      angular.isString(action.supplier.displayName) &&
      angular.isString(action.supplier.contactName) &&
      angular.isString(action.supplier.contactPhone)
    ) {
      returnable = true;
    }
    return returnable;
  }
  function reducer(action, $firedux) {
    return $firedux
      .ref('suppliers')
      .child(action.supplierId)
      .child('metadata')
      .transaction(supplier => {
        supplier = supplier || {};
        return {
          displayName: action.supplier.displayName,
          address: action.supplier.address,
          territories: action.supplier.territories,
          website: action.supplier.website,
          contactName: action.supplier.contactName,
          contactPhone: action.supplier.contactPhone,
          userId: $firedux.auth.uid,
          notes: angular.isString(action.supplier.notes) ? action.supplier.notes : null
        };
      });
  }
  angular
    .module('reducers')
    .run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'SUPPLIER.UPDATE',
      reducer: function (action) {
        return validate(action) ?
          reducer(action, $firedux) :
          Promise.reject('VALIDATION ERROR');
      }
    });
  }
}());
